const TabHome = ({ selected, tabs }) => {
  return (
    <div className="py-0.5 pt-3.5 inline-flex h-[90%] w-full dark:bg-gray-700 bg-gray-200 border-t border-b border-indigo-500 border-opacity-40 dark:border-indigo-500 dark:border-opacity-40 overflow-auto">
      {tabs?.map((tab, index) => (
        <div
          key={index}
          data-current={String(tab.id) === String(selected)}
          className="hidden h-full w-full data-[current=true]:block overflow-auto px-2 pb-2"
        >
          {tab.component}
        </div>
      ))}
    </div>
  );
};

export default TabHome;
